var alignment_rtlignore_default = {
  "alignLeft": "EyqvI",
  "textWrapNowrap": "ietIX",
  "alignRight": "KjQER",
  "alignCenter": "_-1Dme",
  "sizeFullWidth": "_1HgqT",
  "renderedInTable": "sC0r1",
  "sizeOriginal": "Gh--p",
  "sizeContent": "vWn16",
  "sizeSmall": "H5LbX",
  "sizeSmallCenter": "enshz",
  "flex": "Qof26",
  "LEFT": "_6zQ8p",
  "CENTER": "omz53",
  "RIGHT": "e4Ts-",
  "AUTO": "sw7z0",
  "JUSTIFY": "z4PMY"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
